import React from "react";
import styled from "styled-components";

import Footer from "../components/Footer";
import Topbar from "../components/Topbar";
import HeroComp from "../components/HeroComp";
import AboutComp from "../components/AboutComp";

import ContactComp from "../components/ContactComp";

import ServiceComp from "../components/ServiceComp";



const Container = styled.div`
`;

const Content = styled.div`
`;

const Home = () => {
  return (

    <Container>
      <Topbar />
        <Content>
          <HeroComp />
          <AboutComp />
          <ServiceComp />
          <ContactComp />
        </Content>
      <Footer/>
    </Container>
  );
};

export default Home;
